/**
 * Slugify a string for use in `data-testid` attributes.
 * Lowercases, strips diacritics, replaces non-alphanumeric runs with `-`.
 * Empty input returns "unknown".
 */
export function slugify(value) {
    if (value == null) return "unknown";
    const s = String(value)
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "") // strip combining marks
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    return s || "unknown";
}
